import * as React from 'react';

import type {FormattedValue} from 'nutshell-core/types';

import styles from './lead-formatted-value.module.css';

type Props = {
    formattedValue: FormattedValue;
};

export function LeadFormattedValue(props: Props) {
    const {formattedValue} = props;

    return (
        <span className={styles['formatted-value']}>
            <span className={styles['prefix']}>{formattedValue.prefix}</span>
            <span className={styles['value']}>{formattedValue.formatted}</span>
            <span className={styles['suffix']}>{formattedValue.suffix}</span>
        </span>
    );
}
